export function applyDefaultValues(route) {
    const matchedRoute = route.matched[route.matched.length - 1]

    if (matchedRoute && matchedRoute.meta.default) {
        const defaults = matchedRoute.meta.default
        const items = ['params', 'query']

        items.forEach((name) => {
            if (!defaults[name]) {
                return
            }

            Object.keys(defaults[name]).forEach((key) => {
                route[name][key] = route[name][key] || defaults[name][key]
            })
        })
    }

    return route
}

export function applyMiddlewares(route) {
    const matchedRoute = route.matched[route.matched.length - 1]
    const allMiddlewares = route.matched.reduce((middlewares, route) => middlewares.concat(route.meta.middlewares || []), [])

    if (matchedRoute && allMiddlewares) {
        allMiddlewares.forEach((middleware) => {
            if (!matchedRoute.beforeEnter) {
                matchedRoute.beforeEnter = []
            }

            matchedRoute.beforeEnter.unshift(middleware.handle)
        })
    }

    return route
}

export function parseRoutes(routesFromConfig) {
    if (!routesFromConfig) {
        return []
    }

    return routesFromConfig.reduce((routes, route) => {
        return routes.concat([
            {
                path: route.path,
                name: route.name,
                component: route.view ? require(`~/pages/${route.view}Page.vue`).default : undefined,
                redirect: route.redirect,
                children: parseRoutes(route.children),
                beforeEnter: route.beforeEnter,
                meta: { default: route.default, middlewares: route.middlewares, ...route.meta },
            },
        ])
    }, [])
}
